export default "__VITE_ASSET__zZc7YUvz__"